import { TableCell } from '@mui/material'
import { memo, useCallback } from 'react'
import styled from 'styled-components'
import { EXCEL_DATE_NUM_FMT, toReportDateCellAttrs } from '../../utilities'

const cellPrintStyles = `
  @media only print {
    font-size: 10px;
    padding: 4px;
    page-break-inside: avoid;
    page-break-after: auto;
  }
  padding: 10px 4px;
`

export const ReportTableCell = styled(TableCell)`
  ${cellPrintStyles}
`

export const ReportStringTableCell = styled(ReportTableCell).attrs({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'data-t': 's',
})``

const StyledDateTableCell = styled.td`
  ${cellPrintStyles}
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  vertical-align: middle;
`

type ReportDateTableCellProps = {
  value?: string | null
  applicable?: boolean
}

export const ReportDateTableCell = memo(
  ({ value, applicable = true }: ReportDateTableCellProps) => {
    const cell = toReportDateCellAttrs(value, applicable)

    const bindSheetJsAttrs = useCallback(
      (node: HTMLTableCellElement | null) => {
        if (node == null || cell.kind !== 'date') {
          return
        }
        node.setAttribute('t', 'd')
        node.setAttribute('v', cell.isoDate)
        node.setAttribute('z', EXCEL_DATE_NUM_FMT)
      },
      [cell],
    )

    if (cell.kind === 'placeholder') {
      return (
        <ReportStringTableCell>
          <div>{cell.display}</div>
        </ReportStringTableCell>
      )
    }

    return (
      <StyledDateTableCell
        ref={bindSheetJsAttrs}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        data-t="d"
        // eslint-disable-next-line @typescript-eslint/naming-convention
        data-v={cell.isoDate}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        data-z={EXCEL_DATE_NUM_FMT}
      >
        {cell.display}
      </StyledDateTableCell>
    )
  },
)
ReportDateTableCell.displayName = 'ReportDateTableCell'
